import * as Sentry from "@sentry/react";
import type { User } from "openapi/api/model";
import { clearSentryUserMeta, writeSentryUserMeta } from "./sentry-user-meta";

export const clearSentryIdentity = (): void => {
  clearSentryUserMeta();
  Sentry.setUser(null);
};

export const setSentryIdentityFromUser = (user: User): void => {
  const safeUserMeta = {
    id: user.id,
    email: user.email ?? undefined,
    name: user.name ?? undefined,
    orgId: user.organization_id ?? undefined,
  };

  writeSentryUserMeta(safeUserMeta);
  Sentry.setUser({
    id: user.id,
    email: user.email ?? undefined,
    username: user.name ?? undefined,
  });

  if (user.organization_id) {
    Sentry.setTag("organization_id", user.organization_id);
  }
};
